<template>
  <ul class="process-flow">
    <li class="item" v-for="item in list" :key="item.num" :class="{ 'active': item.num >= currentStep }">
      <span class="index">{{item.num}}</span>
      {{item.text}}
      <img
        :src="iconTick"
        alt="完成"
        class="icon"
        v-if="showCheck && item.num < currentStep"
      >
    </li>
  </ul>
</template>

<script>
import iconTick from '../assets/icon_tick.png'
export default {
  data () {
    return {
      iconTick
    }
  },

  props: {
    list: {
      type: Array,
      default: () => []
    },
    currentStep: {
      type: Number,
      default: 100000 // 没有当前步骤，为最大值
    },
    showCheck: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.process-flow {
  background-color: #fff;
  flex: 1 0 auto;
  list-style: none;
  padding: 60px 60px 120px;
  margin: 0;
  display: flex;
  flex-direction: column;
  .item {
    display: block;
    padding-left: 60px;
    height: 40px;
    line-height: 40px;
    position: relative;
    color: $ucar_font_color;
    & + .item {
      margin-top: 50px;
    }
    & + .item:before {
      content: "";
      display: block;
      position: absolute;
      border-left: 1px solid $ucar_main_color; /*no*/
      top: -50px;
      bottom: 40px;
      left: 20px;
      width: 1px;
    }
    .index {
      position: absolute;
      left: 0;
      top: 0;
      display: block;
      width: 38px;
      height: 38px;
      box-sizing: border-box;
      line-height: 34px;
      border: 2px solid $ucar_main_color;
      border-radius: 100%;
      text-align: center;
      color: $ucar_main_color;
    }
    &.active {
      color: $ucar_main_color;
      font-weight: 700;
    }
    &.active .index {
      background-color: $ucar_main_color;
      color: #fff;
    }
    .icon {
      width: 28px;
      height: 28px;
      display: inline-block;
      margin-left: 20px;
    }
  }
}
</style>
